import styles from './Section.module.scss';
import { ReactNode } from 'react';
import clsx from 'clsx';

interface Props {
  children: ReactNode;
  heading?: string;
  spacing?: 'default' | 'top' | 'bottom';
  contained?: boolean;
}

export function Section({ contained, ...props }: Props) {
  const { spacing = 'default' } = props;
  const sectionClassName = [
    styles['section'],
    contained && styles['section-contained'],
    styles['section-spacing-' + spacing],
  ]
    .filter(Boolean)
    .join(' ');

  const heading = props.heading != null && (
    <h2 className={clsx(styles['heading'])}>{props.heading}</h2>
  );

  return (
    <section className={sectionClassName}>
      {heading}
      <div>{props.children}</div>
    </section>
  );
}
